import { css } from '@emotion/react';
import React, { useState } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/schemas';
import { config } from '@config/pendo.config.json';

import { standardSpacing } from 'styles/global_defaults/scaffolding';
import { handheld, notHandheld } from 'styles/global_defaults/media-queries';

import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import InPersonEventConfirmationsModal from './in-person-event-confirmations-modal';
import InPersonEventCheckInModal from './in-person-event-check-in-modal';
import { useInPersonEventContext } from '../in-person-event-context';

const styles = css`
  height: 45px;
  gap: ${standardSpacing}px;
  ${handheld(css`
    flex-direction: column;
  `)};
  ${notHandheld(css`
    flex-direction: row;
  `)}
`;

const InPersonEventAdminActions = () => {
  const { catalogId, sessionId } = useInPersonEventContext();

  const session = useSelector((state: RootState) => state.models.inPersonEventSessions[sessionId]);

  const [showConfirmationsModal, setShowConfirmationsModal] = useState(false);
  const [showCheckInModal, setShowCheckInModal] = useState(false);

  return (
    <>
      <div
        className='w-100 mt-3 d-flex align-items-center justify-content-center py-2 px-3 bg-gray-7'
        css={styles}
      >
        <span className='text-gray-2 text-small font-weight-bold'>
          {t.LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.ADMIN_ONLY()}:
        </span>
        <ClickableContainer
          className='d-flex align-items-center text-primary text-small font-weight-bold'
          onClick={() => setShowConfirmationsModal(true)}
          data-qa={config.pendo.inPersonEvent.adminActions.viewConfirmations}
        >
          <NvIcon icon='groups' size='xss-smallest' className='mr-1' />
          {t.LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.CONFIRMATIONS(session?.confirmedRegistration ?? 0)}
        </ClickableContainer>
        <ClickableContainer
          className='d-flex align-items-center text-primary text-small font-weight-bold'
          onClick={() => setShowCheckInModal(true)}
          data-qa={config.pendo.inPersonEvent.adminActions.learnerCheckIn}
        >
          <NvIcon icon='success' size='xss-smallest' className='mr-1' />
          {t.LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.LEARNER_CHECK_IN()}
        </ClickableContainer>
      </div>

      <InPersonEventConfirmationsModal
        show={showConfirmationsModal}
        onClose={() => setShowConfirmationsModal(false)}
        catalogId={catalogId}
        sessionId={sessionId}
        eventTitle={session?.title ?? ''}
        totalCount={session?.confirmedRegistration ?? 0}
      />
      <InPersonEventCheckInModal
        show={showCheckInModal}
        onClose={() => setShowCheckInModal(false)}
        catalogId={catalogId}
        sessionId={sessionId}
      />
    </>
  );
};

export default InPersonEventAdminActions;
